import { audio } from '../systems/audio/AudioSystem.js';

/** Shop hub: routes to the Echo, Shard, Summon, and Wardrobe pages (M5). */
export class ShopMenu {
  constructor(root, save, { onEcho, onShards, onSummon, onCosmetic, onBack }) {
    this.root = root;
    this.el = document.createElement('div');
    this.el.className = 'menu-overlay shop-hub-overlay';
    this.el.innerHTML = `
      <div class="menu-kicker">RESOURCE EXCHANGE</div>
      <div class="menu-title">SHOP</div>
      <div class="menu-echoes">Echoes: <span class="menu-echoes-value">${save.echoes}</span> &nbsp; Shards: <span class="menu-shards-value">${save.shards}</span> &nbsp; Glimmer: <span class="menu-glimmer-value">${save.glimmer}</span></div>
      <div class="shop-station-grid">
        <button type="button" class="menu-button shop-station-card" data-action="echo"><span class="shop-station-icon">◈</span><b>Echo Upgrades</b><small>Permanent combat stats</small></button>
        <button type="button" class="menu-button shop-station-card" data-action="shards"><span class="shop-station-icon">✦</span><b>Shard Perks</b><small>Run-defining unlocks</small></button>
        <button type="button" class="menu-button shop-station-card" data-action="summon"><span class="shop-station-icon">✧</span><b>Summon</b><small>Collectible companion effects</small></button>
        <button type="button" class="menu-button shop-station-card" data-action="cosmetic"><span class="shop-station-icon">❖</span><b>Wardrobe</b><small>Skins, trails, hats &amp; flair</small></button>
      </div>
    `;
    this.el.querySelector('[data-action="echo"]').addEventListener('click', () => { audio.playSfx('click'); onEcho(); });
    this.el.querySelector('[data-action="shards"]').addEventListener('click', () => { audio.playSfx('click'); onShards(); });
    this.el.querySelector('[data-action="summon"]').addEventListener('click', () => { audio.playSfx('click'); onSummon(); });
    this.el.querySelector('[data-action="cosmetic"]').addEventListener('click', () => { audio.playSfx('click'); onCosmetic(); });

    const back = document.createElement('button');
    back.type = 'button';
    back.className = 'menu-button';
    back.textContent = 'Back';
    back.addEventListener('click', () => { audio.playSfx('click'); onBack(); });
    this.el.appendChild(back);

    this.root.appendChild(this.el);
  }

  destroy() {
    this.el.remove();
  }
}
